// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card {
  margin: 16px 0px 0px 0px !important;
  border-radius: 12px !important;
  border: none !important;
  cursor: pointer;
}

.card-body {
  color: var(--app-legacy-menu-card-text);
  padding: 12px 0px;
}

.card-icon {
  margin: 0px 0px 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: var(--app-font-size-menu-card-icon);
  max-height: var(--app-font-size-menu-card-icon);
  font-size: var(--app-font-size-menu-card-icon);
  line-height: 1;
}

/* Variantes outline da MDI, apenas na apresentação dos cards de menu. */
.card-icon .mdi-school::before {
  content: "\\F1180"; /* mdi-school-outline */
}

.card-icon .mdi-puzzle-check::before {
  content: "\\F01A7"; /* mdi-cube-outline: item do catálogo */
}

.card-icon .mdi-check-decagram::before {
  content: "\\F1740"; /* mdi-check-decagram-outline */
}
.card-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2px;
  min-width: 0;
}

.card-title,
.card-subtitle {
  width: 80%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
}

.card-title {
  margin: 0px;
  font-size: var(--app-font-size-16px);
  font-weight: var(--app-font-weight-bold);
  height: 20px;
  line-height: 20px;
}
.card-subtitle {
  margin: 0px;
  font-size: var(--app-font-size-12px);
  font-weight: var(--app-font-weight-light);
  height: 18px;
  line-height: 18px;
}

.card { border-top: 1.5px solid var(--app-primary) !important; }
`, "",{"version":3,"sources":["webpack://./src/app/shared/components/menu-card/menu-card.component.css"],"names":[],"mappings":"AAAA;EACE,mCAAmC;EACnC,8BAA8B;EAC9B,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,uCAAuC;EACvC,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,2CAA2C;EAC3C,+CAA+C;EAC/C,8CAA8C;EAC9C,cAAc;AAChB;;AAEA,wEAAwE;AACxE;EACE,iBAAiB,EAAE,uBAAuB;AAC5C;;AAEA;EACE,iBAAiB,EAAE,uCAAuC;AAC5D;;AAEA;EACE,iBAAiB,EAAE,+BAA+B;AACpD;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;;EAEE,UAAU;EACV,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,wCAAwC;EACxC,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,oCAAoC;EACpC,yCAAyC;EACzC,YAAY;EACZ,iBAAiB;AACnB;;AAEA,QAAQ,qDAAqD,EAAE","sourcesContent":[".card {\n  margin: 16px 0px 0px 0px !important;\n  border-radius: 12px !important;\n  border: none !important;\n  cursor: pointer;\n}\n\n.card-body {\n  color: var(--app-legacy-menu-card-text);\n  padding: 12px 0px;\n}\n\n.card-icon {\n  margin: 0px 0px 6px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: var(--app-font-size-menu-card-icon);\n  max-height: var(--app-font-size-menu-card-icon);\n  font-size: var(--app-font-size-menu-card-icon);\n  line-height: 1;\n}\n\n/* Variantes outline da MDI, apenas na apresentação dos cards de menu. */\n.card-icon .mdi-school::before {\n  content: \"\\F1180\"; /* mdi-school-outline */\n}\n\n.card-icon .mdi-puzzle-check::before {\n  content: \"\\F01A7\"; /* mdi-cube-outline: item do catálogo */\n}\n\n.card-icon .mdi-check-decagram::before {\n  content: \"\\F1740\"; /* mdi-check-decagram-outline */\n}\n.card-info {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 2px;\n  min-width: 0;\n}\n\n.card-title,\n.card-subtitle {\n  width: 80%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  text-align: center;\n}\n\n.card-title {\n  margin: 0px;\n  font-size: var(--app-font-size-16px);\n  font-weight: var(--app-font-weight-bold);\n  height: 20px;\n  line-height: 20px;\n}\n.card-subtitle {\n  margin: 0px;\n  font-size: var(--app-font-size-12px);\n  font-weight: var(--app-font-weight-light);\n  height: 18px;\n  line-height: 18px;\n}\n\n.card { border-top: 1.5px solid var(--app-primary) !important; }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
